import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import View from '@ckeditor/ckeditor5-ui/src/view';
import Template from '@ckeditor/ckeditor5-ui/src/template';

class CustomImageResize extends Plugin {
    init() {
        const editor = this.editor;

        editor.ui.componentFactory.add('resizeImage', locale => {
            const button = new ButtonView(locale);

            button.set({
                label: 'Resize Image',
                withText: true,
                tooltip: true
            });

            button.on('execute', () => {
                this.showResizeUI();
            });

            return button;
        });
    }

    showResizeUI() {
        const editor = this.editor;
        const balloon = editor.plugins.get('ContextualBalloon');
        const view = new ResizeImageFormView(editor.locale);

        if (balloon.hasView(view)) {
            balloon.remove(view);
        }

        view.on('submit', (evt, data) => {
            const { width, height, unit, alignment } = data;

            if (width === 'full') {
                this.setImageSize('100%', 'auto', alignment);
            } else {
                this.setImageSize(`${width}${unit}`, `${height}${unit}`, alignment);
            }
            balloon.remove(view); // Đóng balloon sau khi submit
        });

        view.on('cancel', () => {
            balloon.remove(view); // Đóng balloon khi cancel
        });

        balloon.add({
            view,
            position: {
                target: editor.ui.view.toolbar.element,
                limiter: editor.ui.getEditableElement()
            }
        });
    }

    setImageSize(width, height, alignment) {
        const editor = this.editor;

        editor.model.change(writer => {
            const selection = editor.model.document.selection;
            const imgElement = selection.getSelectedElement();

            if (!imgElement || !imgElement.is('element', 'image')) {
                console.error('No image selected or invalid element.');
                alert('Please select a valid image.');
                return;
            }

            writer.setAttribute('width', width, imgElement);
            writer.setAttribute('height', height, imgElement);
            writer.setAttribute('class', `align-${alignment}`, imgElement); // Cập nhật căn chỉnh
        });
    }
}

class ResizeImageFormView extends View {
    constructor(locale) {
        super(locale);

        this.width = '';
        this.height = '';
        this.unit = 'px'; // Mặc định là pixel
        this.alignment = 'center'; // Mặc định căn giữa

        const bind = this.bindTemplate;

        this.setTemplate({
            tag: 'form',
            attributes: {
                class: ['ck', 'ck-resize-image-form'],
                tabindex: '-1'
            },
            children: [
                {
                    tag: 'label',
                    children: [{ text: 'Alignment:' }]
                },
                {
                    tag: 'select',
                    attributes: { class: 'ck-input' },
                    children: [
                        { tag: 'option', attributes: { value: 'left' }, children: [{ text: 'Left' }] },
                        { tag: 'option', attributes: { value: 'center' }, children: [{ text: 'Center' }] },
                        { tag: 'option', attributes: { value: 'right' }, children: [{ text: 'Right' }] }
                    ],
                    on: {
                        change: bind.to(evt => {
                            this.alignment = evt.target.value;
                        })
                    }
                },
                {
                    tag: 'label',
                    children: [{ text: 'Width:' }]
                },
                {
                    tag: 'input',
                    attributes: {
                        type: 'number',
                        class: 'ck-input',
                        min: '1'
                    },
                    on: {
                        input: bind.to(evt => {
                            this.width = evt.target.value;
                        })
                    }
                },
                {
                    tag: 'label',
                    children: [{ text: 'Height:' }]
                },
                {
                    tag: 'input',
                    attributes: {
                        type: 'number',
                        class: 'ck-input',
                        min: '1'
                    },
                    on: {
                        input: bind.to(evt => {
                            this.height = evt.target.value;
                        })
                    }
                },
                {
                    tag: 'label',
                    children: [{ text: 'Unit:' }]
                },
                {
                    tag: 'select',
                    attributes: { class: 'ck-input' },
                    children: [
                        { tag: 'option', attributes: { value: 'px' }, children: [{ text: 'Pixels (px)' }] },
                        { tag: 'option', attributes: { value: '%' }, children: [{ text: 'Percentage (%)' }] }
                    ],
                    on: {
                        change: bind.to(evt => {
                            this.unit = evt.target.value;
                        })
                    }
                },
                {
                    tag: 'button',
                    attributes: {
                        type: 'submit',
                        class: 'ck-button ck-button-save'
                    },
                    children: [{ text: 'Apply' }]
                },
                {
                    tag: 'button',
                    attributes: {
                        type: 'button',
                        class: 'ck-button ck-button-cancel'
                    },
                    children: [{ text: 'Cancel' }],
                    on: {
                        click: bind.to(() => {
                            this.fire('cancel');
                        })
                    }
                }
            ],
            on: {
                submit: bind.to(evt => {
                    evt.preventDefault();
                    this.fire('submit', {
                        width: this.width || '100',
                        height: this.height || 'auto',
                        unit: this.unit,
                        alignment: this.alignment
                    });
                })
            }
        });

        this.render();
    }
}

export default CustomImageResize;
